import { Capacitor } from '@capacitor/core';

export function isNativeRuntime(): boolean {
  return Capacitor.isNativePlatform();
}

export function shouldInitFacebookPixel(): boolean {
  return !isNativeRuntime();
}

export function shouldInitFirebaseAnalytics(): boolean {
  return !isNativeRuntime();
}

export function shouldTrackInAppAnalytics(): boolean {
  return true;
}
